import { render, staticRenderFns } from "./addDept.vue?vue&type=template&id=694082db&"
import script from "./addDept.vue?vue&type=script&lang=js&"
export * from "./addDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports